export default {
  sentPartsCheckEnquiry: 'EXP',
  sentManualEnquiry: 'MQE',
  pricedPartsControl: 'IMP',
  pricedPartsControlManual: 'MPR'
}